import axios from 'axios'

export default {
    namespaced: true,
    state: {
        statuses: [],
        statusDialog: false,
        loadingStatuses: false
    },
    mutations: {
        SET_STATUSES(state, statuses) {

            state.statuses = statuses;
        },
        SET_LOADSTATUSES(state, loadingStatuses) {
            state.loadingStatuses = loadingStatuses;
        },
        SET_STATUS_DIALOG(state, status) {
            state.statusDialog = status;
        }
    },
    getters: {
        statuses: state => state.statuses,
        loadingStatuses: state => state.loadingStatuses,
        statusDialog: state => state.statusDialog
    },
    actions: {
        loadStatuses({ commit }) {
            return new Promise(resolve => {
                commit("SET_LOADSTATUSES", true);
                axios.get("/status/get-all").then(res => {
                    commit("SET_STATUSES", res.data.statuses);
                    commit("SET_LOADSTATUSES", false);
                    resolve(res.data.statuses);
                }).catch((e) => {
                    console.log(e);
                    commit("SET_LOADSTATUSES", false);
                });
            })
        }
    },
}

